import { Filters } from 'data/filters/filters.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getCollectionFunctionGroupDataToSubmit(
  filters: Filters,
  originalFilters: Filters | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<Filters> {
  const filtersBody: WithAuditDetails<Filters> = {
    data: filters,
  };

  let actionType = AuditActionType.FILTERS_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.COLLECTION_FUNCTION_GROUP_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(filters, null, isEdit, originalFilters),
      filters.fId,
      AuditService.FILTERS,
      actionType,
    );
    filtersBody.auditDetails = auditDetails as AuditDetails;
  }

  return filtersBody;
}
